import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var Tracking = /*#__PURE__*/function () {
  function Tracking(context) {
    var _this = this;

    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Tracking);

    _defineProperty(this, "shouldTrackAction", function (actionType, itemId) {
      return _this.context.http.post("/msvc/v1/tracking/".concat(actionType, "/").concat(itemId));
    });

    this.context = context;
    this.headers = headers;
  }
  /**
   * Given an id and a step (ActionType) returns the views statistics.
   * Example artwork views(actionType=5) or artwork detail views(actionType=2) into endpoints
   * @param id
   * @param actionType
   * @returns {Promise<*>}
   */


  _createClass(Tracking, [{
    key: "getArtworkReports",
    value: function getArtworkReports(id, actionType) {
      return this.context.http.get("/msvc/v1/tracking/reports/artwork/".concat(id), {
        actionType: actionType
      }, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
    /**
     * Given an array of ids and a step (ActionType) returns the views statistics of each of the artworks.
     * Example artwork views(actionType=5) or artwork detail views(actionType=2) into endpoints
     * @param itemIds
     * @param actionType
     * @returns {Promise<*>}
     */

  }, {
    key: "getArtworksReports",
    value: function getArtworksReports(itemIds, actionType) {
      return this.context.http.get('/msvc/v1/tracking/reports/artworks/views', {
        itemIds: itemIds,
        actionType: actionType
      }, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    } // this function is used to track different actions like when the artwork is marked sold and is visible to the user

  }]);

  return Tracking;
}();

export default Tracking;